import GoldWater from "../views/statistics/goldWater";
// import UserData from '../views/statistics/userData'
// import RevenueData from '../views/statistics/revenueData'
import UserToday from "../views/statistics/userToday";
import VideoIncome from "../views/statistics/videoIncome";
import RechargeLog from "../views/statistics/rechargeLog";
import WithdrawLog from "../views/statistics/withdrawLog";
import ClickStatistics from "../views/statistics/clickStatistics";
import Statistical from "../views/statistics/statistical";
import VideoPayGoldStat from "../views/statistics/videoPayGoldStat";
import VideoKlGoldStat from "../views/statistics/videoKlGoldStat";
import Main from "../views/main";

const StatisticsRouter = {
  path: "/gold-water",
  component: Main,
  title: "统计管理",
  icon: "el-icon-s-data",
  meta: { keepAlive: true },
  children: [
    {
      path: "/gold-water",
      component: GoldWater,
      name: "goldWater",
      title: "金币流水统计",
      meta: { title: "金币流水统计", keepAlive: true },
    },
    //{
    //  path: '/revenue-data',
    //  component: RevenueData,
    //  name: 'revenueData',
    //  title: '营收数据',
    //  meta: { title: '营收数据' ,keepAlive:true}
    //},
    //{
    //  path: '/user-data',
    //  component: UserData,
    //  name: 'userData',
    //  title: '用户观看统计',
    //  meta: { title: '用户观看统计' ,keepAlive:true}
    //},
    {
      path: "/user-today",
      component: UserToday,
      name: "userToday",
      title: "用户每日统计",
      meta: { title: "用户每日统计", keepAlive: true },
    },
    {
      path: "/video-income",
      component: VideoIncome,
      name: "videoIncome",
      title: "视频收入统计",
      meta: { title: "视频收入统计", keepAlive: true },
    },
    {
      path: "/recharge-log",
      component: RechargeLog,
      name: "rechargeLog",
      title: "充值成功统计",
      meta: { title: "充值成功统计", keepAlive: true },
    },
    {
      path: "/withdraw-log",
      component: WithdrawLog,
      name: "withdrawLog",
      title: "提现成功统计",
      meta: { title: "提现成功统计", keepAlive: true },
    },
    {
      path: "/click-statistics",
      component: ClickStatistics,
      name: "clickStatistics",
      title: "广告点击统计",
      meta: { title: "广告点击统计", keepAlive: true },
    },
    {
      path: "/statistical",
      component: Statistical,
      name: "statistical",
      title: "统计报表",
      meta: { title: "统计报表", keepAlive: true },
    },
    {
      path: "/videoPayGoldStat",
      component: VideoPayGoldStat,
      name: "videoPayGoldStat",
      title: "视频销售金币统计",
      meta: { title: "视频销售金币统计", keepAlive: true },
    },
    {
      path: "/videoKlGoldStat",
      component: VideoKlGoldStat,
      name: "videoKlGoldStat",
      title: "视频扣量金币统计",
      meta: { title: "视频扣量金币统计", keepAlive: true },
    },
  ],
};
export default StatisticsRouter;
